import styled from 'styled-components'

import { ActionButtonProps } from './types'
import { getImageSrc } from '../../../utils/local-util'
import { ActionButtonDisplay, ActionButtonTypes } from '../types'

const ActionButton = styled.button<ActionButtonProps>`
  background-image: ${(props) =>
    props.isDisabled ? ` url('${getImageSrc(props.previousButton)}')` : `url('${getImageSrc(props.nextButton)}')`};
  background-repeat: no-repeat;
  background-color: transparent;
  width: 40px;
  height: 40px;
  border: none !important;
  transform: ${(props) => (props.buttonType === ActionButtonTypes.NEXT ? `rotate(0deg)` : `rotate(180deg)`)};
  display: ${(props) => (props.display === ActionButtonDisplay.NONE ? `none` : `display`)};
`

export default ActionButton
